import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../user/service/auth/auth.service';
import {Constant} from '../../global/util/Constant';
import {LocalStorage} from '../../global/util/LocalStorage';
import {EnterpriseService} from '../../user/service/enterprise.service';
import {
  ViewHistoricalBalanceComponent
} from '../../user/components/enterprise/view-historical-balance/view-historical-balance.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Dialog} from '../../global/util/Dialog';
import {DeviceDetectorService} from 'ngx-device-detector';
import {OperatingSystem} from '../../global/util/OperatingSystem';
import {
  ComponentVerificationComponent
} from '../../public/components/component-verification/component-verification.component';
import {InformType} from '../../global/util/enum/InformType';
import {ApplicationService} from '../../user/service/application.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ROLE_USER = Constant.ROLE_USER;
  public ADMIN_IOFE = Constant.ADMIN_IOFE;
  private interval: any;
  public loading = false;
  public isAvailableRCSignature = true;
  siteLanguage = 'Spanish';
  languageList = [
    {code: 'en', label: 'English'},
    {code: 'es', label: 'Spanish'},
  ];

  constructor(private route: Router,
              private authenticationService: AuthService,
              private enterpriseService: EnterpriseService,
              private modalService: NgbModal,
              private deviceService: DeviceDetectorService,
              private applicationService: ApplicationService,
              public translate: TranslateService) {
    this.isAvailableRCSignature = OperatingSystem.Windows === this.deviceService.os ||
      OperatingSystem.iOS === this.deviceService.os ||
      OperatingSystem.macOS === this.deviceService.os;
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.beginAutorefreh();
  }

  logout() {
    this.authenticationService.logout();
    this.route.navigate(['login']);
  }

  login() {
    this.route.navigate(['login']);
  }

  get isAuthenticated() {
    return this.authenticationService.isAuthenticated();
  }

  get profile(): any {
    if (this.authenticationService.getProfile()) {
      return this.authenticationService.getProfile();
    }
    return {
      partnerName: '',
      personName: '',
      jobDescription: '',
      enterpriseNameView: '',
      roles: ''
    };
  }

  /**
   * Verifica si el usuario ha realizado alguna vez una notificación (NOTCER)
   */
  get shippingNotification() {
    if (this.authenticationService.isAuthenticated()) {
      return LocalStorage.shippingNotification();
    } else {
      return false;
    }
  }

  private beginAutorefreh() {
    if (this.isAuthenticated && this.isAllowedViewActualBalance) {
      this.interval = setInterval(() => {
        if (!LocalStorage.showBalanceInfo() || !this.isAuthenticated) {
          return;
        }
        const url = Constant.ROOT_API_V1 + '/actualbalance';
        this.applicationService.get(url).subscribe((value: any) => {
          LocalStorage.setUpEmbeddedInfo(value);
        }, () => {
        });
      }, 5000);
    }
  }

  get existJob(): boolean {
    return this.profile.personType !== Constant.NATURAL_PERSON;
  }

  get hasRoles(): boolean {
    return LocalStorage.getRoles() !== undefined && LocalStorage.getRoles().length > 0;
  }

  public hasRole(role: string) {
    return this.authenticationService.hasRole(role);
  }

  public hasntRole(role: string) {
    return !this.authenticationService.hasRole(role);
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  get role(): string {
    if (this.hasRoles) {
      const role = this.profile.roles[Constant.ZERO_INDEX].abbreviation;
      return '@'.concat(role[0].toUpperCase(), role.substr(1).toLowerCase());
    }
  }

  get hasConfigBalance(): boolean {
    return LocalStorage.hasConfigBalance();
  }

  get actualBalance(): string {
    return LocalStorage.actualBalance().toFixed(4);
  }

  get coin(): string {
    return Constant.IOFE_COIN;
  }

  get isAllowedViewActualBalance(): boolean {
    return this.isAuthenticated
      && this.hasConfigBalance;
    /*      && this.hasntRole(this.ROLE_SUPERADMIN)
          && this.hasntRole(this.ROLE_USER);*/
  }

  get isAllowedViewShoppingcard(): boolean {
    return this.isAuthenticated
      && this.hasConfigBalance
      && this.hasntRole(this.ROLE_SUPERADMIN)
      && this.hasntRole(this.ROLE_PARTNER);
  }

  public openModalViewHistoricalBalance(): void {
    const modalRef = this.modalService.open(ViewHistoricalBalanceComponent, {
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.enterpriseId = LocalStorage.getEnterpriseId();
    modalRef.result.then(() => {
    });
  }

  get urlAbout(): string {
    return LocalStorage.getUrlAbout();
  }

  get urlLogo(): string {
    return LocalStorage.getUrlLogo();
  }

  get base64Logo(): string {
    if (LocalStorage.getBase64Logo() !== 'NOLOGO') {
      return LocalStorage.getBase64Logo();
    } else {
      return this.urlLogo;
    }
  }

  get setupLogo(): boolean {
    return LocalStorage.setupLogo();
  }

  openRCDSignatureDownloadDialog(): void {
    const uuidV1 = require('uuid/v1');
    localStorage.setItem('uuidv1', uuidV1());
    const os = this.deviceService.os;
    let description;
    if (OperatingSystem.Windows === os) {
      description = this.translate.instant('MESSAGE.DONT-HAVE-SIGNATURE-COMPONENT') + os + this.translate.instant('MESSAGE.CLICK') + '<b>' + this.translate.instant('MESSAGE.DOWNLOAD-BUTTON') + '</b>';
    } else if (OperatingSystem.iOS === os || OperatingSystem.macOS === os) {
      description = this.translate.instant('MESSAGE.DONT-HAVE-SIGNATURE-COMPONENT') + os + this.translate.instant('MESSAGE.CLICK') + ' <a target="_blank" href="https://drive.google.com/file/d/18UZyiR8R3DQOIhoUy2iqgFagLVOV8Px-/view?usp=sharing" Data-toggle="tooltip" data-placement="top" title="' + this.translate.instant('MESSAGE.CLICK-TO-DOWNLOAD-COMPONENT') + '"><b> → ' + this.translate.instant('LINK.HERE') + '</b></a>';
    }
    const modalRef = this.modalService.open(ComponentVerificationComponent, {});
    modalRef.componentInstance.description = description;
  }

  get showBalanceInfo() {
    return LocalStorage.showBalanceInfo();
  }

  get isInvitedAuthenticated(): boolean {
    return LocalStorage.isInvitedAuthenticated();
  }

  get onLoginPage(): boolean {
    const onLoginPage = LocalStorage.getItem('onLoginPage');
    if (!onLoginPage) {
      return false;
    }
    return onLoginPage !== 'true';
  }

  get onLoginTempPage(): boolean {
    const onLoginTempPage = LocalStorage.getItem('onLoginTempPage');
    if (!onLoginTempPage) {
      return false;
    }
    return onLoginTempPage !== 'true';
  }

  something() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/required-data?component=list-person');
    this.applicationService.get(url).subscribe((next: any) => {
      this.loading = false;
      LocalStorage.setUpEmbeddedInfo(next);
      this.route.navigate(['person']);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.INITIAL-DATA-OF-PERSON-LIST'), this.translate.instant('MESSAGE.ERROR-LOADING-INITIAL-DATA-ABOUT-PERSON'));
    });
  }

  changeSiteLanguage(localeCode: string): void {
    const selectedLanguage = this.languageList
      .find((language) => language.code === localeCode)
      ?.label.toString();

    if (selectedLanguage) {
      this.siteLanguage = selectedLanguage;
      this.translate.use(localeCode);
    }
  }

  getImageLang() {
    const lang = this.translate.currentLang;
    switch (lang) {
      case 'es':
        return 'flag-icon-pe';
      case 'en':
        return 'flag-icon-us';
      default:
        return 'flag-icon-pe';
    }
  }

  /**
   * Para mostrar el logo desde en enlace público personalizado por empresa, para el registro de usuarios
   * Verificamos que no tenga ninguna sesión activa en el navegados para mostrar el logo de empresa cuando
   * ingresen al enlace
   */
  get logoBase64ByCustomLink(): string {
    if (!this.isAuthenticated) {
      const base64Image = LocalStorage.publicLogoBase64();
      const extension = LocalStorage.extensionLogoBase64();
      if (base64Image !== null && extension !== null) {
        return 'data:image/'.concat(extension).concat(';base64,').concat(base64Image);
      } else {
        return this.urlLogo;
      }
    } else {
      return this.base64Logo;
    }
  }
}
